import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip } from '@mui/material'
import React, { useEffect, useState } from 'react'
import moment from 'moment';
import { displayDateFormatShort } from '../../../constants';
import { trackActivity } from '../../../utils/mixpanel';
import NumericLabel from 'react-pretty-numbers';

const PartialPaymentsModal = ({ onToggleModal, partialPaymentModal }) => {

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `View partial Payment Modal`, page_type: page_type, })
    }
    
    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" className='add-lease-dialog' maxWidth="md" fullWidth open={true} >
                <DialogTitle sx={{ m: 0, p: 2, pl: 3 }} className='dialog-header' id="customized-dialog-title">
                    View Partial Payment
                </DialogTitle>
                <DialogContent dividers>
                    <div>
                        <TableContainer className="lease-detail-table" component={Paper}>
                            <Table className="mui-table-format" stickyHeader sx={{ overflow: 'auto', }}>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Payment Date</TableCell>
                                        <TableCell>Paid Amount</TableCell>
                                        <TableCell>Remaining Amount</TableCell>
                                        <TableCell>Created At</TableCell>
                                        <TableCell>Created By</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {partialPaymentModal?.data?.list?.map((item, index) => 
                                        <TableRow index={index}>
                                            <TableCell>{item.payment_date ? moment(item.payment_date).format(displayDateFormatShort) : '--'}</TableCell>
                                            <TableCell><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item.currency, precision: 2, commafy: true, justification: 'L' }}>{item.amount || 0.00}</NumericLabel></TableCell>
                                            <TableCell><NumericLabel params={{ locales: 'en-GB', currency: true, currencyIndicator: item.currency, precision: 2, commafy: true, justification: 'L' }}>{item.remaining_amount || 0.00}</NumericLabel></TableCell>
                                            <TableCell>{item.created_at ? moment(item.created_at).format(displayDateFormatShort) : '--'}</TableCell>
                                            <TableCell>{item.created_by?.name || '--'}</TableCell>
                                        </TableRow>)}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>
                </DialogContent>
                <DialogActions sx={{ marginRight: "15px" }}>
                    <Button className='cancel-btn' variant='outlined' size='small' onClick={() => { onToggleModal(); handleItemClicked('Cancel Button') }}> Close </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default PartialPaymentsModal